// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2m35-","content":"ManualTimeModal_content__3KqC5"};